<template>
  <v-layout row wrap white>
    <v-flex xs4 ml-5>
      <v-text-field
        v-model="name"
        label="Procurar usuário pelo nome"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      name: ""
    };
  },
  props: {
    searchUsers: Function
  },
  methods: {
    search() {
      this.$props.searchUsers({ name: this.name });
    }
  }
};
</script>

<style>
</style>